import React, { useState, useEffect, useCallback, useRef } from "react";
import * as api from "../services/projectApi";
import { useAuth } from "../../auth/AuthContext";

const fmtSize = (b) => (b > 1e6 ? `${(b / 1e6).toFixed(1)} MB` : `${Math.round(b / 1024)} KB`);

export default function FilesPanel({ projectId }) {
  const { has } = useAuth();
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  const load = useCallback(() => {
    api.listFiles(projectId).then(setFiles).catch((e) => setError(e.response?.data?.message || e.message));
  }, [projectId]);

  useEffect(() => { load(); }, [load]);

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      await api.uploadFile(projectId, file);
      load();
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = async (id) => {
    await api.deleteFile(id);
    load();
  };

  return (
    <div className="proj-panel">
      <div className="proj-progress-head">
        <h4 style={{ margin: 0 }}>Files</h4>
        {has("file.manage") && (
          <>
            <input
              ref={inputRef}
              type="file"
              hidden
              accept=".pdf,.png,.jpg,.jpeg,.docx,.pptx,.xlsx"
              onChange={onPick}
            />
            <button className="proj-btn" disabled={busy} onClick={() => inputRef.current?.click()}>
              {busy ? "Uploading…" : "+ Upload"}
            </button>
          </>
        )}
      </div>
      {error && <div className="proj-alert">{error}</div>}

      <div className="file-list">
        {files.length === 0 && <p className="proj-muted">No files uploaded.</p>}
        {files.map((f) => (
          <div key={f.id} className="file-item">
            <div className="file-meta">
              <strong>{f.originalName}</strong>
              <span className="proj-sub">{fmtSize(f.fileSize)} · {new Date(f.createdAt).toLocaleDateString()}</span>
            </div>
            <div className="file-actions">
              <button className="proj-link" onClick={() => api.downloadFile(f.id, f.originalName)}>download</button>
              {has("file.manage") && (
                <button className="proj-link proj-link-danger" onClick={() => remove(f.id)}>delete</button>
              )}
            </div>
          </div>
        ))}
      </div>
      <p className="proj-hint">Allowed: pdf, png, jpg, docx, pptx, xlsx · max 20MB</p>
    </div>
  );
}
